'use strict';

if (process.env.NODE_ENV === "production") {
  module.exports = require("./emotion-unitless.cjs.prod.js");
} else {
  module.exports = require("./emotion-unitless.cjs.dev.js");
}



//////////////////
// WEBPACK FOOTER
// ./~/@emotion/unitless/dist/emotion-unitless.cjs.js
// module id = 845
// module chunks = 0